import { defaultFilters } from '@shared/utils'
import { AnyObject } from 'antd/lib/_util/type'
import { default as queryString, ParseOptions } from 'query-string'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export const useQueryParams = (
  options: ParseOptions = { arrayFormat: 'comma' }
): AnyObject => {
  const { search } = useLocation()

  const params = useMemo(() => {
    const queryParams = queryString.parse(search, options)

    return { ...defaultFilters, ...queryParams }
  }, [search, options])

  return params
}
